import { useEffect } from 'react';
import './LegalPages.css';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <title>Privacy Policy - Pidesk</title>
      <meta name="description" content="Pidesk's privacy policy for data protection and user privacy" />

      <div className="legal-page">
        <div className="container">
          <div className="legal-content">
            <h1>Privacy Policy</h1>
            <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
            
            <section>
              <h2>Introduction</h2>
              <p>
                Pidesk ("we," "us," or "our") is committed to protecting your privacy and personal data. 
                This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you 
                use our digital website services and products.
              </p>
            </section>

            <section>
              <h2>Information We Collect</h2>
              <h3>Personal Information</h3>
              <ul>
                <li>Name and contact information (email, phone, address)</li>
                <li>Payment information (processed securely through third-party payment gateways)</li>
                <li>Company information (organization name, size, industry)</li>
                <li>Account credentials and login information</li>
                <li>Communication preferences</li>
              </ul>

              <h3>Technical Information</h3>
              <ul>
                <li>IP address and device information</li>
                <li>Browser type and operating system</li>
                <li>Pages visited and time spent on our website</li>
                <li>Cookies and similar tracking technologies</li>
                <li>Usage data and analytics information</li>
              </ul>

              <h3>Website Content</h3>
              <ul>
                <li>Website content you create or upload</li>
                <li>Custom design preferences and requirements</li>
                <li>Project specifications and documentation</li>
                <li>Support communications and feedback</li>
              </ul>
            </section>

            <section>
              <h2>How We Use Your Information</h2>
              <p>We use your information for the following purposes:</p>
              <ul>
                <li>To provide and maintain our digital website services</li>
                <li>To process payments and manage subscriptions</li>
                <li>To communicate with you about your projects and services</li>
                <li>To provide customer support and technical assistance</li>
                <li>To improve our services and develop new features</li>
                <li>To send marketing communications (with your consent)</li>
                <li>To comply with legal obligations and protect our rights</li>
                <li>To analyze usage patterns and optimize user experience</li>
              </ul>
            </section>

            <section>
              <h2>Information Sharing</h2>
              <p>We may share your information in the following circumstances:</p>
              
              <h3>Service Providers</h3>
              <ul>
                <li>Payment processors for transaction processing</li>
                <li>Cloud hosting providers for data storage</li>
                <li>Analytics providers for usage insights</li>
                <li>Email service providers for communications</li>
              </ul>

              <h3>Legal Requirements</h3>
              <ul>
                <li>When required by law, court order, or government regulation</li>
                <li>To protect our rights, property, or safety</li>
                <li>To prevent fraud or illegal activities</li>
                <li>In connection with business transfers or mergers</li>
              </ul>
            </section>

            <section>
              <h2>Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal data, including:
              </p>
              <ul>
                <li>SSL encryption for data transmission</li>
                <li>Secure authentication and access controls</li>
                <li>Regular security audits and updates</li>
                <li>Limited access to personal information</li>
                <li>Secure backup and disaster recovery procedures</li>
              </ul>
              <p>
                However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <h2>Cookies and Tracking</h2>
              <p>
                We use cookies and similar technologies to enhance your experience:
              </p>
              <ul>
                <li>Essential cookies for website functionality</li>
                <li>Analytics cookies to understand usage patterns</li>
                <li>Marketing cookies for personalized content</li>
                <li>Preference cookies to remember your settings</li>
              </ul>
              <p>
                You can control cookie settings through your browser preferences.
              </p>
            </section>

            <section>
              <h2>Your Rights</h2>
              <p>Depending on your location, you may have the following rights:</p>
              <ul>
                <li>Access to your personal information</li>
                <li>Correction of inaccurate information</li>
                <li>Deletion of your personal information</li>
                <li>Restriction of processing</li>
                <li>Data portability</li>
                <li>Objection to processing</li>
                <li>Withdrawal of consent</li>
              </ul>
            </section>

            <section>
              <h2>Data Retention</h2>
              <p>
                We retain your personal information only as long as necessary to fulfill the purposes outlined in this policy, 
                unless a longer retention period is required by law.
              </p>
            </section>

            <section>
              <h2>International Data Transfers</h2>
              <p>
                Your information may be transferred to and processed in countries other than your own. We ensure appropriate 
                safeguards are in place to protect your data in accordance with applicable data protection laws.
              </p>
            </section>

            <section>
              <h2>Children's Privacy</h2>
              <p>
                Our services are not intended for children under 13. We do not knowingly collect personal information from 
                children under 13. If we become aware of such collection, we will take steps to delete it immediately.
              </p>
            </section>

            <section>
              <h2>Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the 
                updated policy on our website and updating the "Last updated" date.
              </p>
            </section>

            <section>
              <h2>Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy or want to exercise your rights, please contact us:
              </p>
              <ul>
                <li>Email: privacy@pidesk.com</li>
                <li>Phone: +1 (555) 123-4567</li>
                <li>Address: 123 Business Ave, Suite 100, City, State 12345</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
